import { instance } from '../api'

export const axiosPlugin = {
    install: (app) => {
        app.config.globalProperties.axios = instance
    }
}

export default axiosPlugin